export default {
  init() {
    // JavaScript to be fired on all pages
    var $hamburger = $(".hamburger");
    $hamburger.on("click", function() {
      $hamburger.toggleClass("is-active");
      // Do something else, like open/close menu
      $("#navbarNav").toggleClass("show");
      $("header").toggleClass("is-open");
      $("body").toggleClass("menu-open");
    });



    function detect_scrolled(){

      if($(window).scrollTop() > 150){
        $( "#header" ).addClass( "scrolled" );
      } else{
        $( "#header" ).removeClass( "scrolled" );
      }
      //var scrolledY = $(window).scrollTop() -60;
      // $('.header-video .embed-responsive').css('top', ((scrolledY)) + 'px');
      /*& var scrolledY = $(window).scrollTop();
        $('#block-0446961a .cta-common').css('background-position', 'center ' + ((scrolledY)) + 'px');*/

    }

    var scrollInterval = null;

    $(window).scroll(function(){ detect_scrolled(); });

    $(window).on('touchmove', function() {
      scrollInterval = window.setInterval("detect_scrolled", 100);
    });
    $(window).on('touchend', function() {
      clearInterval(scrollInterval);
    });

    if($(window).scrollTop() > 150){
      $( "#header" ).addClass( "scrolled" );
    }

    var userAgent = navigator.userAgent.toLowerCase();
    const isTablet = /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(userAgent);
    console.log(isTablet);
    if(isTablet === false){
      $('.fcb-blocks > div').addClass('out');
      $('.fcb-blocks > div').each(function () {
        $(this).appear(function () {
          $(this).removeClass('out');
        });
      });
      $('.fcb-image_block').removeClass('out');
      $('.fcb-post_grid .post-item').addClass('out');
      $('.fcb-post_grid .post-item').each(function () {
        $(this).appear(function () {
          $(this).removeClass('out');
        });
      });
    } else {
      $('.fcb-post_grid .video_container').css('display','none');
    }

    $(window).load(function() {
         // + any other carousel related stuff that has to wait for the images to complete loading
         $('.carousel').carousel();

         /*$('.carousel').each(function () {
           $(this).carousel('pause');
           $(this).appear(function () {
             $(this).carousel('cycle');
           });
         });*/
    })






      var offset;
      offset = $('#header').innerHeight();


      $('a[href*="#"]:not([href="#"]):not(a.carousel-control-prev):not(a.carousel-control-next):not(a.expand-link):not(.panel-title a):not(li.li-search a), area[href*="#"]').click(function() {
        if (location.pathname.replace(/^\//,'') === this.pathname.replace(/^\//,'') && location.hostname === this.hostname) {
          var target = $(this.hash);
          target = (target.length ? target : $('[name=' + this.hash.slice(1) +']'));
          if (target.length) {
            $('html,body').animate({
              scrollTop: target.offset().top - offset,
            }, 1000);
            $("#header").addClass("scrolled");
            return false;
          }
        }
      });

      $('.down_arrow').click(function() {
        var arrow_to_top = $(this).closest('.down_arrow').position().top + $(this).closest('.down_arrow').outerHeight(true);
        $('html,body').animate({
          scrollTop: arrow_to_top - offset,
        }, 1000);
        $("#header").addClass("scrolled");
      });



  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

    function getHashFilter() {
      //var hash = location.hash;
      // get filter=filterName
      var matches = location.hash.match(/filter=([^&]+)/i);
      var hashFilter = matches && matches[1];
      return hashFilter && decodeURIComponent(hashFilter);
    }

  // init Isotope
    var $grid = $('.grid_isotope').isotope({
      layoutMode: 'fitRows',
      fitRows: {
        gutter: 0,
      },
      itemSelector: '.post-item',
      percentPosition: false,
    });

    // bind filter button click
    var $filters = $('#filters').on('click', 'button', function () {
      var filterAttr = $(this).attr('data-filter');
      // set filter in hash
      location.hash = 'filter=' + encodeURIComponent(filterAttr);
    });

      // bind filter on select change
    var $filters2 = $('.filters-select').on( 'change', function() {
      // get filter value from option value
      var filterValue = this.value;
      // use filterFn if matches value
      filterValue = encodeURIComponent(filterValue);
      $grid.isotope({ filter: filterValue });
    });

    var isIsotopeInit = false;

    function onHashchange() {
      var hashFilter = getHashFilter();
      if (!hashFilter && isIsotopeInit) {
        return;
      }
      isIsotopeInit = true;
      // filter isotope
      $grid.isotope({
        itemSelector: '.post-item',
        filter: hashFilter,
      });
      // set selected class on button
      if (hashFilter) {
        $filters.find('.is-checked').removeClass('is-checked');
        $filters.find('[data-filter="' + hashFilter + '"]').addClass('is-checked');
        $filters2.find('.is-checked').removeClass('is-checked');
        $filters2.find('[data-filter="' + hashFilter + '"]').addClass('is-checked');
      }
    }

    $(window).on('hashchange', onHashchange);
    // trigger event handler to init Isotope
    onHashchange();

    $('[data-toggle="popover"]').popover();


  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js